import React, { useState } from 'react';
import { Box, Typography, Menu, MenuItem, ListItemIcon, ListItemText, Divider } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { FIELD_CATEGORIES } from './fieldTypes';
import { NODE_UI } from '../../../NodeUI/nodeUiStyles';

export default function AddFieldButton({ onSelect, position, palette, alwaysVisible = false }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (e) => {
    e.stopPropagation();
    setAnchorEl(e.currentTarget);
  };

  const handleClose = () => setAnchorEl(null);

  const handleSelect = (type) => {
    onSelect(type, position);
    handleClose();
  };

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        py: alwaysVisible ? '4px' : '3px',
      }}
    >
      <Box
        onClick={handleClick}
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: '4px',
          px: '10px',
          py: '4px',
          borderRadius: '100px',
          border: `1px dashed ${palette.border}`,
          backgroundColor: palette.surface,
          cursor: 'pointer',
          transition: 'all 0.15s ease',
          userSelect: 'none',
          '&:hover': {
            borderColor: palette.textSecondary,
            borderStyle: 'solid',
            backgroundColor: palette.surfaceSubtle,
            boxShadow: NODE_UI.shadow,
          },
        }}
      >
        <AddIcon sx={{ width: 15, height: 15, color: palette.textSecondary }} />
        <Typography sx={{ fontSize: '12px', fontWeight: 500, color: palette.textSecondary }}>
          Add field
        </Typography>
      </Box>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        transformOrigin={{ vertical: 'top', horizontal: 'center' }}
        slotProps={{
          paper: {
            sx: {
              maxWidth: 240,
              maxHeight: 360,
              borderRadius: '8px',
              boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
              mt: '4px',
            },
          },
        }}
      >
        {FIELD_CATEGORIES.map((cat, catIdx) => [
          catIdx > 0 && <Divider key={`div-${catIdx}`} />,
          <Typography
            key={`cat-${cat.label}`}
            sx={{
              px: '16px',
              pt: catIdx === 0 ? '8px' : '6px',
              pb: '4px',
              fontSize: '11px',
              fontWeight: 700,
              textTransform: 'uppercase',
              letterSpacing: '0.05em',
              color: 'text.secondary',
              userSelect: 'none',
            }}
          >
            {cat.label}
          </Typography>,
          ...cat.types.map((t) => {
            const Icon = t.icon;
            return (
              <MenuItem
                key={t.value}
                onClick={() => handleSelect(t.value)}
                sx={{
                  px: '16px',
                  py: '6px',
                  minHeight: 0,
                  mx: '4px',
                  borderRadius: '4px',
                  '&:hover': { backgroundColor: 'action.hover' },
                }}
              >
                <ListItemIcon sx={{ minWidth: '28px !important' }}>
                  <Icon sx={{ width: 16, height: 16 }} />
                </ListItemIcon>
                <ListItemText
                  primary={t.label}
                  primaryTypographyProps={{ fontSize: '13px', fontWeight: 500 }}
                />
              </MenuItem>
            );
          }),
        ])}
      </Menu>
    </Box>
  );
}
